import {del, get, post, put} from './base'

export function getMessage(data){
    return get('/v3/push/message',data)
}
export function postMessage(data){
    return post('/v3/push/message',data)
}
export function putMessage(data){
    return put('/v3/push/message',data)
}
export function delMessage(id){
    return del('/v3/push/message/'+id)
}
export function getReceive(data){
    return get('/v3/push/receive',data)
}
